import { Component, ElementRef, HostListener, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoResume, DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from '../environments/environment';
import { AndriodpopupComponent } from './andriodpopup/andriodpopup.component';
import { ConformComponent } from './conform/conform.component';
import { SessiontempComponent } from './sessiontemp/sessiontemp.component';
import { MyserviceService, Puser, User, UserService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  @HostListener('window:onbeforeunload', ['$event'])
  unloadHandler(event) {
    localStorage.clear();
  }
  deviceInfo = null;
  currentUser: User;
  public User: any = User;
  PUser: any = Puser;
  public idletime = environment.idletime
  public timeset = environment.timeset
  idleState = 'NOT_STARTED';
  timedOut = false;
  lastPing?: Date = null;
  progressBarPopup: MatDialogRef<SessiontempComponent>;
  expires: MatDialogRef<ConformComponent>;
  andpopup: MatDialogRef<AndriodpopupComponent>;


  constructor(
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    private dialog: MatDialog,
    public sessionService: MyserviceService,
    private element: ElementRef,
    private idle: Idle,
    private keepalive: Keepalive,
  ) {
    //this.epicFunction();
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(2);
    };
  }

  ngOnInit() {
    const userAgent = navigator.userAgent;
    const isAndroidPhone = userAgent.search("Android") != -1 && userAgent.search("Mobile") != -1;

    if (navigator.userAgent.search("iPhone") != -1 && location.href.search("createnewpass") == -1
      && location.href.search("welcome") == -1) {
      this.router.navigateByUrl('/appstore')
      location.href = "iRC-apps://itunes.apple.com/lookup?bundleId=com.sol.iRecoveryCOACH";
      setTimeout(function () { location.href = "https://apps.apple.com/us/app/rc-coach/id1475273242"; }, 10000);
    }

    if (isAndroidPhone && location.href.search("createnewpass") == -1
      && location.href.search("welcome") == -1) {
      this.router.navigateByUrl('/appstore')
      this.andpopup = this.dialog.open(AndriodpopupComponent, { hasBackdrop: true, disableClose: true });
      this.andpopup.componentInstance.message = 'Open this page in RC-COACH?';
      this.andpopup.componentInstance.android = true;
      setTimeout(function () { location.href = "https://play.google.com/store/apps/details?id=com.ind.solvedge.recoverycoach"; }, 5000);
      //location.href  = "RC-COACH://";
    }

    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.hasOwnProperty("item"))
          this.resetTimeOut("reset");
        else
          this.resetTimeOut("init");
      }
    )
    this.userService.populate();
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  session(type) {
    this.ngZone.runOutsideAngular(() => {
      this.sessionService.setState("NOT_STARTED");

      this.idle.setIdle(this.idletime);

      this.idle.setTimeout(this.timeset);

      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');

      this.idle.onIdleEnd.subscribe(() => {
        this.idleState = 'NO_LONGER_IDLE';
      });

      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
      });

      this.idle.onTimeout.subscribe(() => {
        this.ngZone.run(() => {
          this.idleState = 'TIMED_OUT';
          this.timedOut = true;
          this.progressBarPopup.close();
          this.resetTimeOut("init");
          window.localStorage['session'] = true;
          this.logout();
        })
      });

      this.idle.onIdleStart.subscribe(() => {
        this.ngZone.run(() => {
          this.idleState = 'IDLE_START';
          this.idle.setAutoResume(AutoResume.notIdle);
          this.openProgressForm(1);
        });
      });

      this.idle.onTimeoutWarning.subscribe((countdown: any) => {
        this.sessionForm(countdown);
      });

      this.keepalive.interval(15);
      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

      if (type == "reset") {
        this.idle.watch();
      }
      this.sessionService.setIdleObject(this.idle);
    });
  }

  public openProgressForm(count: number) {
    this.progressBarPopup = this.dialog.open(SessiontempComponent, { hasBackdrop: true, disableClose: true });
    this.progressBarPopup.componentInstance.count = count;
    this.progressBarPopup.afterClosed().subscribe(result => {
      this.progressBarPopup.close();
      if (result == 'logout') {
        this.logout();
      } else {
        this.resetTimeOut("reset");
      }
    });
  }

  logout() {
    this.userService.logoutuser(this.currentUser.item.userAccountId)
    this.userService.purgeAuth();
    this.resetTimeOut("init");
    if (window.localStorage['plogin']) {
      var plogin = window.localStorage['plogin']
      window.localStorage.removeItem('plogin');
      this.router.navigateByUrl('/plogin/' + plogin);
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  closeProgressForm() {
    this.progressBarPopup.close();
  }

  resetTimeOut(type) {
    try {
      this.idle.stop();
      this.idle.onTimeout.observers.length = 0;
      this.idle.onIdleStart.observers.length = 0;
      this.idle.onIdleEnd.observers.length = 0;
      this.idle.onTimeoutWarning.observers.length = 0;
      this.session(type);
    }
    catch (error) { }
  }

  public sessionForm(countdown: any): any {
    this.idleState = 'IDLE_TIME_IN_PROGRESS';
    this.progressBarPopup.componentInstance.count = (Math.floor((countdown - 1) / 60) + 1);
    this.progressBarPopup.componentInstance.progressCount = this.reverseNumber(countdown);
    this.progressBarPopup.componentInstance.countSeconds = (countdown - 1) % 60;
  }

  reverseNumber(countdown: number) {
    return 2 * (60 - (countdown - 1));
  }

}
